<template>
    <div class="animated fadeIn ringingHolds">
        <filters :scope="filtersScope"/>

        <div class="statistic-wrap">
            <div class="card statistic-table">
                <div>
                    <div class="card-block" >
                        <div class="card-header">Прозвон холдов</div>
                        <table class="table">
                                <thead>
                                    <tr>
                                        <th rowspan="2" style="background-color: rgb(224, 224, 224); width: 100px;">Дата</th>
                                        <th rowspan="2" style="background-color: rgb(224, 224, 224)">Лидов</th>
                                        <th colspan="2" style="background-color: rgb(224, 224, 224)">Отработано</th>
                                        <th rowspan="2" style="background-color: rgb(255, 249, 196)">Дозвон на<br> 1 день</th>
                                        <th colspan="3" style="background-color: rgb(255, 249, 196)">Апрув на 1 день</th>
                                        <th rowspan="2" style="background-color: rgb(255, 230, 155);">Дозвон на<br> 2 день</th>
                                        <th colspan="3" style="background-color: rgb(255, 230, 155);">Апрув на 2 день</th>
                                        <th rowspan="2" style="background-color: rgb(255, 224, 131);">Дозвон на<br> 3 день</th>
                                        <th colspan="3" style="background-color: rgb(255, 224, 131);">Апрув на 3 день</th>
                                        <th rowspan="2"  style="background-color: rgb(255, 217, 106);">Дозвон на<br> 4 день</th>
                                        <th colspan="3" style="background-color: rgb(255, 217, 106);">Апрув на 4 день</th>
                                        <th colspan="3" style="background-color: rgb(129, 199, 132);">Апрув</th>
                                    </tr>
                                <tr class="th-level-2">
                                    <th style="background-color: rgb(224, 224, 224)">касаний</th>
                                    <th style="background-color: rgb(224, 224, 224)">звонков</th>
                                    <th style="background-color: rgb(255, 249, 196)">лидов</th>
                                    <th style="background-color: rgb(255, 249, 196)">апрув</th>
                                    <th style="background-color: rgb(255, 249, 196)">процент</th>

                                    <th style="background-color: rgb(255, 230, 155)">лидов</th>
                                    <th style="background-color: rgb(255, 230, 155)">апрув</th>
                                    <th style="background-color: rgb(255, 230, 155)">процент</th>

                                    <th style="background-color: rgb(255, 224, 131)">лидов</th>
                                    <th style="background-color: rgb(255, 224, 131)">апрув</th>
                                    <th style="background-color: rgb(255, 224, 131)">процент</th>

                                    <th style="background-color: rgb(255, 217, 106)">лидов</th>
                                    <th style="background-color: rgb(255, 217, 106)">апрув</th>
                                    <th style="background-color: rgb(255, 217, 106)">процент</th>

                                    <th style="background-color: rgb(129, 199, 132);">апрув</th>
                                    <th style="background-color: rgb(129, 199, 132);">процент</th>
                                    <th style="background-color: rgb(129, 199, 132);">от валида</th>
                                </tr>
                                </thead>
                                <tbody v-for="row in rows">
                                <tr>
                                    <td style="background-color: rgb(224, 224, 224)">
                                        {{row.date}}
                                    </td>
                                    <td style="background-color: rgb(224, 224, 224)">
                                        {{row.total_processed}}
                                    </td>
                                    <td style="background-color: rgb(224, 224, 224)">
                                        {{row.average_changes}}
                                    </td>
                                    <td style="background-color: rgb(224, 224, 224)">
                                        {{row.average_calls}}
                                    </td>


                                    <td style="background-color: rgb(255, 249, 196)">
                                        {{row.ring_up_one_day_ago}}%
                                    </td>
                                    <td style="background-color: rgb(255, 249, 196)">
                                        {{row.created_one_day_ago}}
                                    </td>
                                    <td style="background-color: rgb(255, 249, 196)">
                                        {{row.approved_one_day_ago}}
                                    </td>
                                    <td style="background-color: rgb(255, 249, 196)">
                                        {{row.created_one_day_ago > 0 ? ((row.approved_one_day_ago / row.created_one_day_ago) * 100).toFixed(1) + '%' : '0%'}}
                                    </td>


                                    <td style="background-color: rgb(255, 230, 155);">
                                        {{row.ring_up_two_days_ago}}%
                                    </td>
                                    <td style="background-color: rgb(255, 230, 155);">
                                        {{row.created_two_days_ago}}
                                    </td>
                                    <td style="background-color: rgb(255, 230, 155);">
                                        {{row.approved_two_days_ago}}
                                    </td>
                                    <td style="background-color: rgb(255, 230, 155);">{{row.created_two_days_ago > 0 ? ((row.approved_two_days_ago / row.created_two_days_ago) * 100).toFixed(1) + '%' : '0%'}}</td>

                                    <td style="background-color: rgb(255, 224, 131);">
                                        {{row.ring_up_three_days_ago}}%
                                    </td>
                                    <td style="background-color: rgb(255, 224, 131);">
                                        {{row.created_three_days_ago}}
                                    </td>
                                    <td style="background-color: rgb(255, 224, 131);">
                                        {{row.approved_three_days_ago}}
                                    </td>
                                    <td style="background-color: rgb(255, 224, 131);">{{row.approved_three_days_ago > 0 ? ((row.approved_three_days_ago / row.created_three_days_ago) * 100).toFixed(1) + '%' : '0%'}}</td>

                                    <td style="background-color: rgb(255, 217, 106);">
                                        {{row.ring_up_more_three_days_ago}}%
                                    </td>
                                    <td style="background-color: rgb(255, 217, 106);">
                                        {{row.created_more_three_days_ago}}
                                    </td>
                                    <td style="background-color: rgb(255, 217, 106);">
                                        {{row.approved_more_three_days_ago}}
                                    </td>
                                    <td style="background-color: rgb(255, 217, 106);">{{row.created_more_three_days_ago > 0 ? ((row.approved_more_three_days_ago / row.created_more_three_days_ago) * 100).toFixed(1) + '%' : '0%'}}</td>

                                    <td style="background-color: rgb(129, 199, 132);">{{row.total_approved}}</td>
                                    <td style="background-color: rgb(129, 199, 132);">{{((row.total_approved / row.total_processed) * 100).toFixed(1) + '%'}}</td>
                                    <td style="background-color: rgb(129, 199, 132);">{{approvedFromValid(row.total_approved, row.total_processed, row.total_spam)}}</td>

                                </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th v-for="item in this.footColumns">{{item}}</th>
                                    </tr>
                                </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Filters from '@/components/Filters.vue'
  import API from '../../../api/API'
  import {map} from 'lodash'
  import Helper from '../../../api/Helper'

export default {
    components: {
      Filters
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          byWmFilter: true
        },
        rows: [],
        footColumns: {}
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      approvedFromValid (approved, total, spam) {
        return `${((approved / (total - spam)) * 100).toFixed(1)}%`
      },
      async calculateRows () {
        this.rows = []
        this.footColumns = {}
        let sumTotalProcessed = 0
        let sumChanges = 0.0
        let sumCalls = 0.0
        let ringOneDay = 0.0
        let createdOneDay = 0
        let approvedOneDay = 0
        let ringTwoDay = 0.0
        let createdTwoDay = 0
        let approvedTwoDay = 0
        let ringThreeDay = 0.0
        let createdThreeDay = 0
        let approvedThreeDay = 0
        let ringMoreDay = 0.0
        let createdMoreDay = 0
        let approvedMoreDay = 0
        let totalApproved = 0
        let totalSpam = 0
        await API.getRingingHolds().then(response => {
          this.rows = response.body

          map(response.body, d => {
            if (d.total_processed > 0) {
              sumTotalProcessed += parseInt(d.total_processed)
            }
            if (d.average_changes && d.total_processed > 0) {
              sumChanges += (d.average_changes * d.total_processed)
            }
            if (d.average_calls > 0) {
              sumCalls += (d.average_calls * d.total_processed)
            }

            if (d.ring_up_one_day_ago > 0) {
              ringOneDay += (d.ring_up_one_day_ago * d.total_processed)
            }
            if (d.created_one_day_ago > 0) {
              createdOneDay += parseInt(d.created_one_day_ago)
            }
            if (d.approved_one_day_ago > 0) {
              approvedOneDay += parseInt(d.approved_one_day_ago)
            }

            if (d.ring_up_two_days_ago > 0) {
              ringTwoDay += (d.ring_up_two_days_ago * d.total_processed)
            }
            if (d.created_two_days_ago > 0) {
              createdTwoDay += parseInt(d.created_two_days_ago)
            }
            if (d.approved_two_days_ago > 0) {
              approvedTwoDay += parseInt(d.approved_two_days_ago)
            }

            if (d.ring_up_three_days_ago > 0) {
              ringThreeDay += (d.ring_up_three_days_ago * d.total_processed)
            }
            if (d.created_three_days_ago > 0) {
              createdThreeDay += parseInt(d.created_three_days_ago)
            }
            if (d.approved_three_days_ago > 0) {
              approvedThreeDay += parseInt(d.approved_three_days_ago)
            }

            if (d.ring_up_more_three_days_ago > 0) {
              ringMoreDay += (d.ring_up_more_three_days_ago * d.total_processed)
            }
            if (d.created_more_three_days_ago > 0) {
              createdMoreDay += parseInt(d.created_more_three_days_ago)
            }
            if (d.approved_more_three_days_ago > 0) {
              approvedMoreDay += parseInt(d.approved_more_three_days_ago)
            }

            if (d.total_approved > 0) {
              totalApproved += parseInt(d.total_approved)
            }
            totalSpam += parseInt(d.total_spam)
          })
        })
        this.footColumns = {
          label: 'Итого',
          total_processed: sumTotalProcessed,
          average_changes: `${(sumChanges / sumTotalProcessed).toFixed(2)}`,
          average_calls: `${(sumCalls / sumTotalProcessed).toFixed(2)}`,
          ring_one_day: `${(ringOneDay / sumTotalProcessed).toFixed(2)} %`,
          created_one_day: createdOneDay,
          approved_one_day: approvedOneDay,
          percent_one_day: `${Helper.percentHungry(approvedOneDay, createdOneDay)}`,
          ring_two_day: `${(ringTwoDay / sumTotalProcessed).toFixed(2)} %`,
          created_two_day: createdTwoDay,
          approved_two_day: approvedTwoDay,
          percent_two_day: `${Helper.percentHungry(approvedTwoDay, createdTwoDay)}`,
          ring_three_day: `${(ringThreeDay / sumTotalProcessed).toFixed(2)} %`,
          created_three_day: createdThreeDay,
          approved_three_day: approvedThreeDay,
          percent_three_day: `${Helper.percentHungry(approvedThreeDay, createdThreeDay)}`,
          ring_more_day: `${(ringMoreDay / sumTotalProcessed).toFixed(2)} %`,
          created_more_day: createdMoreDay,
          approved_more_day: approvedMoreDay,
          percent_more_day: `${(approvedMoreDay / createdMoreDay).toFixed(2)} %`,
          total_approved: totalApproved,
          percent_approved: `${Helper.percentHungry(totalApproved, sumTotalProcessed)}`,
          approvedFormValid: Helper.approvedFromValid(totalApproved, sumTotalProcessed, totalSpam)
        }
      }
    }
  }
</script>

<style scoped>
    .ringingHolds td {
        padding: 10px;
        vertical-align: inherit;
    }
    .ringingHolds th {
        vertical-align: middle;
    }
    .th-level-2 th {
        font-weight: 400;
    }
    tfoot th {
        border: 1px solid #eee;
    }
</style>



// WEBPACK FOOTER //
// RingingHolds.vue?2464921c